import omit from 'lodash/omit';

const jwTokenInitial = null;
export const jwToken = (state = jwTokenInitial, action = {}) => {
  switch (action.type) {
    case 'AUTH_SET_TOKEN':
      return action.payload;
    case 'AUTH_CLEAR':
      return jwTokenInitial;
    default:
      return state;
  }
};

const userInitial = null;
export const user = (state = userInitial, action = {}) => {
  switch (action.type) {
    case 'AUTH_SET_USER':
      return action.payload;
    case 'AUTH_UPDATE_USER':
      return { ...state, ...action.payload };
    case 'AUTH_CLEAR':
      return userInitial;
    default:
      return state;
  }
};

const profileStatusInitial = { setup: false, errors: null };
export const profileStatus = (state = profileStatusInitial, action = {}) => {
  switch (action.type) {
    case 'AUTH_SET_PROFILE_ERRORS':
      return { ...state, errors: action.payload };
    case 'AUTH_SET_PROFILE_SETUP':
      return { ...state, setup: true };
    case 'AUTH_CLEAR_PROFILE_USERNAME_ERROR':
      return { ...state, errors: omit(state.errors, 'username') };
    case 'AUTH_CLEAR_PROFILE_DNI_ERROR':
      return {
        ...state,
        errors: {
          ...omit(state.errors, 'dni'),
          errors: { ...omit(state.errors?.errors, 'dni') },
        },
      };
    case 'AUTH_CLEAR':
      return profileStatusInitial;
    default:
      return state;
  }
};

export const authLoading = (state = false, action = {}) => {
  switch (action.type) {
    case 'AUTH_LOADING':
      return action.payload;
    default:
      return state;
  }
};

export const authChecked = (state = false, action = {}) => {
  switch (action.type) {
    case 'AUTH_CHECKED':
      return action.payload;
    case 'AUTH_CLEAR':
      return false;
    default:
      return state;
  }
};

export const authOAuthError = (state = false, action = {}) => {
  switch (action.type) {
    case 'AUTH_OAUTH_ERROR':
      return true;
    case 'AUTH_CLEAR':
    case 'AUTH_SET_TOKEN':
      return false;
    default:
      return state;
  }
};
